import React from 'react';

/**
 * Users tab — read-only list of all registered users with balances + checks.
 */
export default function UsersTab({ users }) {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-lg overflow-hidden" data-testid="admin-users-tab">
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="users-table">
          <thead className="bg-zinc-950 text-zinc-400 text-xs uppercase">
            <tr>
              <th className="text-left px-4 py-2">Email</th>
              <th className="text-left px-4 py-2">Name</th>
              <th className="text-right px-4 py-2">Balance</th>
              <th className="text-right px-4 py-2">Lifetime earn</th>
              <th className="text-right px-4 py-2">Checks</th>
              <th className="text-left px-4 py-2">Joined</th>
            </tr>
          </thead>
          <tbody>
            {users.users.map((u) => (
              <tr key={u.user_id} className="border-t border-zinc-800" data-testid="users-row">
                <td className="px-4 py-2">{u.email}</td>
                <td className="px-4 py-2">{u.name}</td>
                <td className="px-4 py-2 text-right font-mono text-[#00D26A]">£{Number(u.withdrawable_balance || 0).toFixed(2)}</td>
                <td className="px-4 py-2 text-right font-mono">£{Number(u.total_earnings || 0).toFixed(2)}</td>
                <td className="px-4 py-2 text-right">{u.total_checks || 0}</td>
                <td className="px-4 py-2 text-zinc-500 text-xs">{(u.created_at || '').slice(0, 10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
